import { IResolvers } from '@workbench-stack/core';

export const quickInputModelResolver: (services: any) => IResolvers = (services: any) => ({
    Query: {

    },
    Mutation: {
        showInput: async (_, args, context) => {
            await services().quickInputService.input(args.options);
            return true;
        },
        showPickInput: async (_, args, context) => {
            await services().quickInputService.pick(args.items, args.options);
            return true;
        },
        hideInputModel: async (_, args, context) => {
            await services().quickInputService.cancel();
            return true;
        },
        setSelected: async (_, args, context) => {
            await services().quickInputService.setSelected(args.selectedValue, args.inputValue);
            return true;
        },
    },
});
